import { render } from "./ComparativeAppendix.vue?vue&type=template&id=1a1058e4"
import script from "./ComparativeAppendix.vue?vue&type=script&lang=js"
export * from "./ComparativeAppendix.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__